import { render, staticRenderFns } from "./DeleteLessonModal.vue?vue&type=template&id=4ca26b09&"
import script from "./DeleteLessonModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteLessonModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports